import { Injectable } from "@angular/core";
import { ApprovalTypeId, MCDialog, MCDialogButton, MCDialogFooter, MCDialogHeader } from "@maslul/common-services";
import { RequestApprovalTypeDetailsStore } from "../store/approval-type-details-store";
import { TABS } from "../../enum/request/TABS";
import { GeneralDetailsStore } from "../store/general-details";
import { ProductsStoreService } from "../store/products";
import { RequestDetailsStore } from "../store/request-details";
import { AttachmentsStore } from "../store/attachments";
import { DeclarationsStore } from "../store/declarations";


@Injectable({
    providedIn: 'root',
})
export class ApprovalTypesService {

    public readonly maxCountRowsToApprovalTypeId: { [approvalTypeId: number]: number } = {};

    constructor(
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore,
        private generalDetailsStore: GeneralDetailsStore,
        private productsStoreService: ProductsStoreService,
        private requestDetailsStore: RequestDetailsStore,
        private attachmentsStore: AttachmentsStore,
        private declarationsStore: DeclarationsStore
    ) {
        this.initMaxCountRowList();
    }

    initMaxCountRowList() {
        this.maxCountRowsToApprovalTypeId[ApprovalTypeId.COMMUNICATION_ADJUSTMENT_DISPOSABLE_PRIVATE] = 5;
        this.maxCountRowsToApprovalTypeId[ApprovalTypeId.COMMUNICATION_TYPE_DISPOSABLE] = 5;
        this.maxCountRowsToApprovalTypeId[ApprovalTypeId.STANDARDS_EXEMPT_PI] = 1;
        this.maxCountRowsToApprovalTypeId[ApprovalTypeId.PersonalImport] = 5;
    }

    isExistTabToApproval(tab: TABS | number) {
        const isExist = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(tab);
        return isExist;
    }

    clearStoreOnApprovalChange() {
        this.generalDetailsStore.initStore();
        this.requestApprovalTypeDetailsStore.initStore();
        this.productsStoreService.initStore();
        this.requestDetailsStore.initStore();
        this.attachmentsStore.initStore();
        this.declarationsStore.initStore();
        window.sessionStorage.clear();
    }

    showDialogOnApprovalChange(dialogProperties: MCDialog, dialogText: any) {
        dialogProperties.visible = true;


        dialogProperties.header = new MCDialogHeader();
        dialogProperties.header.closeButton = new MCDialogButton();
        dialogProperties.header.closeButton.label = "X";
        dialogProperties.header.closeButton.event = () => { dialogProperties.visible = false };

        dialogProperties.footer = new MCDialogFooter();
        dialogProperties.footer.button = new MCDialogButton();
        dialogProperties.footer.button.label = dialogText.okButton;
        dialogProperties.footer.button.event = () => {
            this.clearStoreOnApprovalChange();
            dialogProperties.visible = false
        };


        dialogProperties.footer.secondButton = new MCDialogButton();
        dialogProperties.footer.secondButton.label = dialogText.cancelButton;
        dialogProperties.footer.secondButton.class = "mi-white-button";
        dialogProperties.footer.secondButton.event = () => { dialogProperties.visible = false };
    }

    isChangeAprovalType(approvalTypeId: string): boolean {
        const approvalTypeIdFromStore = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTypeId;
        return approvalTypeIdFromStore !== '' && approvalTypeIdFromStore !== approvalTypeId.toString();
    }
}